import React from 'react';
import cx from 'classnames';

// eslint-disable-next-line react/prop-types
const ShopLocation = ({ map, shopName, line1, line2, phone, directions, fixed }) => (
  <div className={cx('c-shop-location', { 'c-shop-location--fixed': fixed })}>
    <img src={map} alt="" />
    <div className="u-pt-6 u-pr-4 u-pb-4 u-pl-4 u-flex-1 u-flex u-justify-content-center">
      <div className="u-ta-left">
        <div className="u-text-normal u-fw-bold u-mb-2">
          {shopName}
        </div>
        <div className="u-text-small u-co-grey u-mb-3">
          {line1},<br />
          {line2}<br />
          {phone}
        </div>
        <a className="u-text-normal u-co-grey" href={directions} target="_blank">
          Get directions
        </a>
      </div>
    </div>
  </div>
);

export default ShopLocation;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/ShopLocation.jsx